import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { DEMAND_DETAIL_FEEDBACK_RECEIVED } from '../feedback/demand-detail-feedback-actions';
import { DemandAccountParticipantFormValues } from '../../../../models/demand-account-participant';
import { DemandNotificationContact } from '../../../../models/demand-notification-contact';
import { ParticipantsFormValues } from '../../models/participants-form-values';
import { StepData } from '../../../../../../common/components/new-stepper/step-data';

export const DEMAND_DETAIL_PARTICIPANTS_SUBMIT = 'DEMAND_DETAIL_PARTICIPANTS_SUBMIT';
export const DEMAND_DETAIL_PARTICIPANTS_RECEIVED = 'DEMAND_DETAIL_PARTICIPANTS_RECEIVED';

export const submitParticipants = (data: StepData<ParticipantsFormValues>) => ({
    type: DEMAND_DETAIL_PARTICIPANTS_SUBMIT,
    data,
});

export const fetchParticipants = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demandId = getState().demandDetail.overview.stepData.values.id;

        if (demandId === undefined) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return;
        }

        const response = await api.demands.cgetParticipants(demandId);
        if (response.success) {
            dispatch({ type: DEMAND_DETAIL_PARTICIPANTS_RECEIVED, participants: response.result });
            dispatch({ type: DEMAND_DETAIL_FEEDBACK_RECEIVED, participants: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveParticipants = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demandId = getState().demandDetail.overview.stepData.values.id;
        const participants = getState().demandDetail.participants.stepData.values.participants ?? [];

        if (demandId === undefined) {
            return false;
        }

        const notificationContacts = participants.map(
            (participant: DemandAccountParticipantFormValues): DemandNotificationContact => ({
                demandAccountId: participant.id >= 0 ? participant.id : null,
                customerAccountId: participant.id <= 0 ? participant.customer.id : null,
                // already validated on submit
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                contactId: participant.contact!.id,
                isSelected: participant.isSelected,
            })
        );

        const response = await api.demands.updateNotificationContacts(demandId, notificationContacts);
        if (response.success) {
            dispatch({ type: DEMAND_DETAIL_PARTICIPANTS_RECEIVED, participants: response.result });
            dispatch({ type: DEMAND_DETAIL_FEEDBACK_RECEIVED, participants: response.result });
        } else {
            return false;
        }

        return true;
    };
};
